import React from 'react';

import style from './page.module.scss';

import { Header } from '../header/header';
import { Footer } from '../footer/footer';

export const Page = ({ path, Main }) => {
    return (
        <div className={style.page}>
            <Header path={path}></Header>
            <Main className={style.main}></Main>
            <Footer></Footer>
        </div>
    );
};
